import { createAction } from "@ngrx/store";
import { LanguageModel } from "../models/language.model";
import {
  AssetCategoryModel,
  CostCenterModel,
  CountryEmergencyContacts,
  NationalEmergencyContacts,
} from "../models/asset.model";
import { LocationsModel } from "../models/master.model";
import { SiteSegmentModel } from "../models/siteSegment.model";

export const ADD_COST_CENTERS = createAction(
  "ADD_COST_CENTERS",
  (costCenters: CostCenterModel[]) => ({ costCenters }),
);

export const ADD_LANGUAGES = createAction(
  "ADD_LANGUAGES",
  (languages: LanguageModel[]) => ({ languages }),
);

export const ADD_CATEGORIES = createAction(
  "ADD_CATEGORIES",
  (categories: AssetCategoryModel[]) => ({ categories }),
);

export const ADD_MASTER_LOCATIONS = createAction(
  "MASTER_LOCATIONS",
  (locations: LocationsModel) => ({
    locations,
  }),
);

export const ADD_NATIONAL_EMERGENCY = createAction(
  "ADD_NATIONAL_EMERGENCY ",
  (nationalEmergencies: CountryEmergencyContacts[]) => ({
    nationalEmergencies,
  }),
);

export const ADD_SITE_SEGMENTS = createAction(
  "ADD_SITE_SEGMENTS",
  (siteSegments: SiteSegmentModel[]) => ({ siteSegments }),
);